import { AddImageSVG } from "../svgs/AddImageSVG";

export function ImageDropZoneArea({
  children,
  dropZoneText,
}: {
  children: React.ReactNode;
  dropZoneText: React.ReactNode;
}) {
  return (
    <div className="group relative">
      {children}
      <div className="group border-4 border-dashed border-gray-300 p-10 flex flex-col items-center justify-center mb-8 rounded-sm">
        {/* <input
          type="file"
          className="absolute inset-0 block z-25 w-full opacity-0"
          // onDrop={handlers.fileDropEventHandler}
          // onChange={handlers.fileInputEventHandler}
        /> */}
        <div className="group-hover:stroke-teal-600 stroke-gray-500">
          <AddImageSVG className="stroke-inherit " />
        </div>
        <div className="group-hover:text-teal-600 flex items-center flex-col justify-center ">
          {dropZoneText}
        </div>
      </div>
    </div>
  );
}

function InputDrop({
  onDrop,
  onChange,
}: {
  onDrop?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <input
      type="file"
      className="absolute inset-0 block z-1 w-full opacity-0"
      onDrop={onDrop}
      onChange={onChange}
    />
  );
}

ImageDropZoneArea.Handler = InputDrop;
